/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleSeriesValuesResponseDTO } from './SingleSeriesValuesResponseDTO';
import {
    SingleSeriesValuesResponseDTOFromJSON,
    SingleSeriesValuesResponseDTOFromJSONTyped,
    SingleSeriesValuesResponseDTOToJSON,
} from './SingleSeriesValuesResponseDTO';

/**
 * 
 * @export
 * @interface SeriesValuesResponseDTO
 */
export interface SeriesValuesResponseDTO {
    /**
     * 
     * @type {Array<SingleSeriesValuesResponseDTO>}
     * @memberof SeriesValuesResponseDTO
     */
    series: Array<SingleSeriesValuesResponseDTO>;
}

/**
 * Check if a given object implements the SeriesValuesResponseDTO interface.
 */
export function instanceOfSeriesValuesResponseDTO(value: object): value is SeriesValuesResponseDTO {
    if (!('series' in value) || value['series'] === undefined) return false;
    return true;
}

export function SeriesValuesResponseDTOFromJSON(json: any): SeriesValuesResponseDTO {
    return SeriesValuesResponseDTOFromJSONTyped(json, false);
}

export function SeriesValuesResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesValuesResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'series': ((json['series'] as Array<any>).map(SingleSeriesValuesResponseDTOFromJSON)),
    };
}

export function SeriesValuesResponseDTOToJSON(value?: SeriesValuesResponseDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'series': ((value['series'] as Array<any>).map(SingleSeriesValuesResponseDTOToJSON)),
    };
}

